import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name:''
  },
  mutations: {
    //username
    _name(state,name){
      state.name = name
    }
  },
  actions: {
        // 获取用户信息
        info(context, state) {
          return new Promise((resolve, reject) => {
            console.log('获取用户信息')
            context.commit("_name", '1');
            // userinfo().then(res => {
            //   context.commit("__user", res.data);
            //   context.commit("_name",res.data.name);
            // }).catch(error => {
            //   reject(error)
            // })
          });
        },
  },
  modules: {
  }
})
